import type {AuthorPublicInfo} from "./user";
import type {Tag} from "./tag";
import type {SingleCategory} from "./singleCategory";

export interface AllNews {
    count: number;
    next: string;
    previous: string;
    results: [{
        id: number;
        title: string;
        description: string;
        author: AuthorPublicInfo;
        editor_suggestion: boolean;
        tags: Tag[];
        video?: string | null; // Nullable field
        category: SingleCategory;
        type: 'news' | 'video'; // Enum field
        thumbnail?: string | null; // Nullable field
        created_at: string; // ISO date format
        updated_at: string; // ISO date format
        published_at: string; // ISO date format
    }]
}

export interface SingleNews {
    data: {
        id: number;
        title: string;
        description: string;
        author: AuthorPublicInfo;
        editor_suggestion: boolean;
        tags: Tag[];
        video?: string | null; // Nullable field
        category: SingleCategory;
        type: 'news' | 'video'; // Enum field
        thumbnail?: string | null; // Nullable field
        created_at: string; // ISO date format
        updated_at: string; // ISO date format
    }
}

export interface AllNewsFilter {
    search?: string;
    category?: number;
    tag?: number;
    type?: 'news' | 'video';
    editor_suggestion?: boolean;
    popular?: boolean;
    page?: number;
    page_size?: number;
}

export const newsTypeOptions = [{value: null, label: 'همه'}, {value: 'article', label: 'مقاله'}, {
    value: 'news',
    label: 'خبر'
}, {value: 'video', label: 'ویدیو'}, {value: 'sm', label: 'شبکه‌های اجتماعی'}]